<div class="error-toast animate__animated animate__fadeInUp">
    <span style="width: 25px;min-width: 25px;">
        <ng-lottie [options]="errorOptions"></ng-lottie>
    </span>
    <span>{{message}}</span>
</div>